import * as React from 'react';
export const IcTriangle = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.73 16.99l-7-12C13.37 4.38 12.71 4 12 4s-1.37.38-1.73.99l-7 12c-.36.62-.36 1.38 0 2 .36.62 1.02 1 1.73 1h14c.72 0 1.38-.38 1.73-1 .35-.62.35-1.39 0-2z'
      fill='currentColor'
    />
  </svg>
);
